
const companyFullcont        = require('./company-fullcont')

export function start(detail){  //console.log('company-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/


const obj = {
   

      fullcont:           { start: (detail)=>{  companyFullcont. start(detail)        }},


}







